import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { QrcodeComponent } from '@ui/qrcode/qrcode.component';

@Component({
    selector: 'payment-qr',
    templateUrl: './payment-qr.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        QrcodeComponent,
    ],
})
export class PaymentQrComponent {
    @Input() public mainText: string[];

    @Input() public pendingText: string[];

    @Input() public cancelledText: string[];

    @Input() public qr: string;

    @Input() public total: string;

    @Input() public image: string;

    @Input() public pending: boolean;

    @Input() public cancelled: boolean;
}
